<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts">
export default {
  name: 'AppLayout',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'

import { useRoute } from 'vue-router'
import EmptyLayout from '@/layouts/Empty.vue'
import MainLayout from '@/layouts/Main/Main.vue'

const route = useRoute()

const layout = computed(() => (route.meta?.layout === 'empty' ? EmptyLayout : MainLayout))
</script>
